module.exports = __webpack_public_path__ + "img/icon-search.ccb1920a.svg";